/**
 * Mock-data fallback gating.
 *
 * The original API service files unconditionally returned hardcoded mock
 * payloads when a real call failed (catch blocks that returned a fake array
 * or object literal instead of letting the rejection propagate).
 * That meant instructors saw fake data when the backend was actually down
 * — silent failures, no error state, no toast, no opportunity to recover.
 *
 * We keep the dev affordance (mocks help when the backends aren't running
 * locally) but gate it behind an explicit env flag. In production builds
 * the flag is off, so React Query sees the rejection and surfaces an
 * error state the UI can react to.
 *
 * Set `REACT_APP_USE_MOCK_DATA=true` in `.env.development` to keep the
 * mock behaviour while iterating on the UI without the platform up.
 */
export const USE_MOCK_DATA = process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_MOCK_DATA === 'true';

/**
 * In dev (with the flag on), return the mock payload. Otherwise rethrow
 * the original error so React Query / TanStack can surface it.
 */
export function mockFallback<T>(error: unknown, mock: T): T {
  if (USE_MOCK_DATA) {
    return mock;
  }
  throw error;
}
